<template>
  <div class="fill-height d-flex flex-column white">
    <div v-if="isMobileView" class="px-4 py-4 white">
      <vs-button
        class="overlay-button"
        :icon="navStore.isNavVisible ? 'mdi-menu-open' : 'mdi-menu'"
        type="secondary"
        @click="navStore.toggleNav"
      />
    </div>
    <v-divider v-if="isMobileView" />
    <v-row no-gutters class="flex-grow-1" align="center" justify="center">
      <v-col class="invoice-upsell-wrapper">
        <vs-wrapper padding="large">
          <div class="text-center">
            <v-icon size="92" color="primary">mdi-file-document-outline</v-icon>
          </div>
          <vs-heading class="text-center" type="headline">Streamline your invoicing</vs-heading>
          <vs-text class="text-center" type="intro">
            Seamlessly sync field tickets and invoices to QuickBooks Online and other invoicing
            platforms. Contact
            <a href="mailto:sales@ironsight.app?subject=Invoicing Feature Inquiry"
              >sales@ironsight.app</a
            >
            to get set up.
          </vs-text>
          <div class="text-center">
            <a
              href="https://www.ironsight.app/quickbooks-online"
              target="_blank"
              rel="noopener noreferrer"
              >Learn more</a
            >
          </div>
        </vs-wrapper>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts" setup>
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsText from '@/components/vision/VsText.vue'
import VsButton from '@/components/vision/VsButton.vue'
import { useScreen } from '@/common/useScreen'
import { useNavStore } from '@/components/nav/navStore'

const { isMobileView } = useScreen()
const navStore = useNavStore()
</script>

<style scoped>
.invoice-upsell-wrapper {
  max-width: 640px;
}
</style>
